<!-- Body1 slot -->
<section>
  <cx-page-slot position="Body1" />
</section>

<!-- SEO slot -->
<section>
  <cx-page-slot position="SEO" />
</section>
